module.exports = __webpack_public_path__ + "img/teacher3.e6cddf4e.png";